import Tether from 'tether';

const ModuleData = Symbol('xTether');

const transitionModule = {
  position() {
    const className = `${this.options.classPrefix}-transition`;
    const hasClass = Tether.Utils.hasClass(this.element, className);
    const data = this[ModuleData] || (this[ModuleData] = {});
    const shouldAddClass = data.prevTarget && this.target !== data.prevTarget;

    if (!hasClass && shouldAddClass) {
      Tether.Utils.addClass(this.element, className);
    } else if (hasClass && !shouldAddClass) {
      Tether.Utils.removeClass(this.element, className);
    }

    this[ModuleData].prevTarget = this.target;
  },
};

Tether.modules.push(transitionModule);

export default Tether;



/** WEBPACK FOOTER **
 ** ./src/components/xtether.js
 **/